<template>
  <button
    type="button"
    class="kwadrat"
    :aria-label="`Liczba ${number100}. Kliknij, aby wylosować kolejną.`"
    @click="random100"
  >
    <img
      :src="'./img/' + number100 + '.jpg'"
      :alt="`Skojarzenie dla liczby ${number100}`"
    />
  </button>
</template>

<script>
export default {
  data() {
    return {
      number100: 77,
      // number100txt: 'background-image: url(./img/' + this.number100 + '.jpg)',
    };
  },
  emits: ['number100-value'],
  methods: {
    random100() {
      this.number100 = Math.floor(Math.random() * 100)
        .toString()
        .padStart(2, '0');
      this.$emit('number100-value', this.number100);
    },

    // make100txt() {
    //   this.number100txt =
    //     'background-image: url(./img/' + this.number100 + '.jpg)';
    // },

    // random100() {
    //   this.number100 = getRandomNumber(100).toString().padStart(2, '0');
    //   console.log(this.number100);
    // },

    // getRandomNumber(maxNumber) {
    //   return Math.floor(Math.random() * maxNumber);
    // },
  },
  mounted() {
    this.$emit('number100-value', this.number100);
  },
};
</script>

<style scoped>
.kwadrat {
  border-top-right-radius: 30px;
  border-bottom-right-radius: 30px;
}

img {
  border-top-right-radius: 30px;
  border-bottom-right-radius: 30px;
}
/* header {
  width: 100%;
  height: 5rem;
  background-color: #f7007b;
  display: flex;
  justify-content: center;
  align-items: center;
}

header h1 {
  color: white;
  margin: 0;
} */
</style>
